import { render } from "./slide-10.vue?vue&type=template&id=e4541e64&scoped=true"
import script from "./slide-10.vue?vue&type=script&lang=js"
export * from "./slide-10.vue?vue&type=script&lang=js"

import "./slide-10.vue?vue&type=style&index=0&id=e4541e64&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4541e64"]])

export default __exports__